import { CustomSelectFieldProps, SelectField } from 'components/form'
import { useServerTime } from 'hooks/useServerTime'
import { useMemo } from 'react'

export interface AnoSelectModel {
  id: ID
  nome: string
}

export const AnoSelectField = (props: CustomSelectFieldProps<AnoSelectModel>) => {
  const { getServerTimeNow } = useServerTime()
  const serverTime = getServerTimeNow()

  const items = useMemo(() => getAnos(serverTime), [serverTime])

  return <SelectField<AnoSelectModel> {...props} items={items} itemToString={itemToString} />
}

const itemToString = (item: AnoSelectModel) => (item ? item.nome : '')

const getAnos = (serverTime: Date): AnoSelectModel[] => {
  const anoAtual = serverTime.getFullYear()

  return Array.from({ length: 100 }, (_, index) => ({
    id: index + 1,
    nome: String(anoAtual - index),
  }))
}
